import { Box, Avatar, Typography, Stack, Paper, Button } from '@mui/material'
import { useAuth0 } from '@auth0/auth0-react'
import { useStore } from '~/state/useStore'
import { PageHeader } from '~/components/Navigation/PageHeader'

export function Profile() {
  const user = useStore((s) => s.auth.user)
  const { logout } = useAuth0()
  if (!user) return null
  return (
    <Box sx={{ p: 4 }}>
      <PageHeader title="Profil" />
      <Paper sx={{ p: 3, maxWidth: 480 }}>
        <Stack direction="row" spacing={3} alignItems="center">
          {user.picture ? <Avatar src={user.picture} /> : <Avatar>{user.name[0]}</Avatar>}
          <Box>
            <Typography variant="h6">{user.name}</Typography>
            <Typography color="text.secondary">{user.email}</Typography>
            <Typography variant="caption" color="text.secondary">
              Rolle: {user.role}
            </Typography>
          </Box>
        </Stack>
        <Box sx={{ mt: 3 }}>
          <Button
            variant="outlined"
            onClick={() => logout({ logoutParams: { returnTo: window.location.origin } })}
          >
            Abmelden
          </Button>
        </Box>
      </Paper>
    </Box>
  )
}
